export default function initAnchorLinks() {
    const urlHash = window.location.hash;

    if (urlHash) {
        const elToScroll = document.querySelector(decodeURI(urlHash));
        if (elToScroll) {
            elToScroll.classList.add("is--open");
            const word = document.querySelector(`[data-slug=${elToScroll.id}]`);
            if (word) {
                word.classList.add("is--active");
            }

            /* Reassign event scroll (window.scrollBy) that is called in admin-bar.js
            *  Otherwise this current code doesn't work when user logged in WP
            */
            if (document.querySelector('body').classList.contains('admin-bar')){
                document.addEventListener("DOMContentLoaded", () => {
                    window.scrollTo({
                        left: 0,
                        top: elToScroll.offsetTop - document.querySelector(".siteHeader").offsetHeight,
                        behavior: "smooth"
                    });
                });
            }
            /*       */

            window.scrollTo({
                left: 0,
                top: elToScroll.offsetTop - document.querySelector(".siteHeader").offsetHeight,
                behavior: "smooth"
            });
        }
    }
}
